module.exports = __webpack_public_path__ + "img/character-board.317bae23.png";